<template>
  <video
    id="player-container-id"
    style="object-fit: fill"
    webkit-playsinline
    playsinline
    x5-video-player-type="h5"
    x5-video-player-fullscreen="false"
    allowfullscreen="false"
    webkitallowfullscreen="false"
    mozallowfullscreen="false"
  ></video>
</template>
<script>
export default {
  props: {
    srcURL: {
      type: String,
      default: '',
    },
    showSoundControl: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tcPlayer: null,
  }),
  mounted() {
    this.tcPlayer = TCPlayer('player-container-id', {
      sources: [
        {
          src: this.srcURL,
        },
      ],
      controlBar: {
        fullscreenToggle: false,
      },
    });
  },
  beforeDestroy() {
    this.tcPlayer.dispose();
    this.tcPlayer = null;
  },
};
</script>
<style>
#player-container-id {
  .vjs-volume-panel {
    display: none !important;
  }
}
</style>
